/* AddictaLash lash quiz (replaces Octane AI).
 * Flow: 5 questions -> email capture (skippable) -> loading screen -> result.
 * The result is chosen from the "Lash look" and "Eye shape" answers, matching the Octane logic.
 * Result pages are server-rendered by sections/al-lash-quiz.liquid and only revealed here. */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (key) {
        var val = attrs[key];
        if (val === null || val === undefined || val === false) return;
        if (key === 'text') node.textContent = val;
        else if (key === 'html') node.innerHTML = val;
        else if (key === 'style') node.setAttribute('style', val);
        else if (key.indexOf('on') === 0) node.addEventListener(key.slice(2), val);
        else node.setAttribute(key, val === true ? '' : val);
      });
    }
    (children || []).forEach(function (child) {
      if (child) node.appendChild(child);
    });
    return node;
  }

  function Quiz(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector('script[data-alq-config]').textContent);
    this.stage = root.querySelector('[data-alq-stage]');
    this.resultsWrap = root.querySelector('[data-alq-results]');
    this.answers = {};
    this.email = '';
    this.emailGiven = false; // the 20% off is the reward for leaving an email
    this.result = null;
    this.stepIndex = 0;
    this.steps = this.cfg.questions.map(function (q) { return { type: 'question', q: q }; });
    if (this.cfg.email.enabled) this.steps.push({ type: 'email' });
    this.steps.push({ type: 'loading' });
    this.bindResults();
    this.go(0, true);
  }

  Quiz.prototype.go = function (index, initial) {
    this.stepIndex = index;
    var step = this.steps[index];
    this.stage.innerHTML = '';
    this.stage.hidden = false;
    this.resultsWrap.hidden = true;
    var view;
    if (step.type === 'question') view = this.renderQuestion(step.q, index);
    else if (step.type === 'email') view = this.renderEmail(index);
    else view = this.renderLoading();
    this.stage.appendChild(view);
    if (!initial) this.scrollTop();
    var focusTarget = view.querySelector('.alq-title');
    if (focusTarget && !initial) {
      focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({ preventScroll: true });
    }
  };

  Quiz.prototype.scrollTop = function () {
    var top = this.root.getBoundingClientRect().top + window.pageYOffset - 120;
    if (window.pageYOffset > top) window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  };

  Quiz.prototype.head = function (title, subtitle) {
    return el('div', { class: 'alq-head' }, [
      el('h2', { class: 'alq-title', text: title }),
      subtitle ? el('p', { class: 'alq-subtitle', text: subtitle }) : null
    ]);
  };

  Quiz.prototype.backButton = function (index) {
    var self = this;
    if (index === 0) return null;
    return el('button', {
      type: 'button',
      class: 'alq-back',
      text: self.cfg.backText,
      onclick: function () { self.go(index - 1); }
    });
  };

  Quiz.prototype.renderQuestion = function (q, index) {
    var self = this;
    var isImage = q.layout === 'image';
    var list = el('ul', {
      class: 'alq-options ' + (isImage ? 'alq-options--image' : 'alq-options--text') + (q.textPosition === 'above' ? ' alq-options--text-above' : ''),
      role: 'radiogroup',
      'aria-label': q.title,
      style: isImage ? '--alq-cols:' + q.perRow + ';--alq-cols-m:' + q.perRowMobile + ';--alq-content:' + q.contentSize : null
    });

    q.options.forEach(function (opt) {
      var selected = self.answers[q.id] === opt.label;
      var label = el('span', { class: 'alq-option__label', text: opt.label });
      var img = isImage ? el('span', { class: 'alq-option__img' }, [
        el('img', { src: opt.image, alt: opt.label, width: 400, height: 400, loading: index === 0 ? 'eager' : 'lazy', decoding: 'async' })
      ]) : null;
      var item = el('li', {
        class: 'alq-option' + (selected ? ' is-selected' : ''),
        role: 'radio',
        tabindex: '0',
        'aria-checked': selected ? 'true' : 'false',
        'aria-label': opt.label
      }, isImage ? (q.textPosition === 'above' ? [label, img] : [img, label]) : [label]);

      var choose = function () {
        if (list.dataset.locked) return;
        list.dataset.locked = '1';
        list.querySelectorAll('.alq-option').forEach(function (o) {
          o.classList.remove('is-selected');
          o.setAttribute('aria-checked', 'false');
          if (o !== item) o.classList.add('is-disabled');
        });
        item.classList.add('is-selected');
        item.setAttribute('aria-checked', 'true');
        self.answers[q.id] = opt.label;
        setTimeout(function () { self.go(index + 1); }, 350);
      };
      item.addEventListener('click', choose);
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(); }
      });
      list.appendChild(item);
    });

    return el('div', { class: 'alq-step', 'data-step': q.id }, [
      this.head(q.title, q.subtitle),
      list,
      this.backButton(index)
    ]);
  };

  Quiz.prototype.renderEmail = function (index) {
    var self = this;
    var c = this.cfg.email;
    var input = el('input', {
      class: 'alq-input',
      type: 'email',
      name: 'email',
      autocomplete: 'email',
      inputmode: 'email',
      placeholder: c.placeholder,
      'aria-label': c.placeholder,
      value: this.email || null
    });
    var submit = el('button', { type: 'submit', class: 'alq-btn alq-btn--primary alq-btn--large', text: c.submitText });
    var error = el('p', { class: 'alq-error', role: 'alert' });
    var sync = function () { submit.disabled = !input.value.trim(); };
    input.addEventListener('input', function () { error.textContent = ''; sync(); });
    sync();

    var form = el('form', { class: 'alq-email-form', novalidate: true }, [
      input,
      error,
      submit,
      c.allowSkip ? el('button', {
        type: 'button',
        class: 'alq-textbtn',
        text: c.skipText,
        onclick: function () { self.email = ''; self.go(index + 1); }
      }) : null
    ]);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var value = input.value.trim();
      if (!EMAIL_RE.test(value)) {
        error.textContent = c.invalidText;
        input.focus();
        return;
      }
      self.email = value;
      self.emailGiven = true;
      self.captureEmail(value);
      self.go(index + 1);
    });

    return el('div', { class: 'alq-step', 'data-step': 'email' }, [
      this.head(c.title, c.subtitle),
      c.image ? el('div', { class: 'alq-media', style: 'max-width:' + c.imageWidth + 'px' }, [el('img', { src: c.image, alt: '', loading: 'lazy' })]) : null,
      c.disclaimer ? el('div', { class: 'alq-rich', html: c.disclaimer }) : null,
      form,
      this.backButton(index)
    ]);
  };

  Quiz.prototype.renderLoading = function () {
    var self = this;
    var c = this.cfg.loading;
    this.pickResult();
    // Load the chosen result's photos during the loading screen so they show instantly.
    if (this.result) {
      Array.prototype.forEach.call(this.result.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
    }
    setTimeout(function () { self.showResult(); }, Math.max(0, c.seconds) * 1000);
    return el('div', { class: 'alq-step', 'data-step': 'loading', 'aria-live': 'polite' }, [
      this.head(c.title, c.subtitle),
      c.image ? el('div', { class: 'alq-media', style: 'max-width:' + c.imageWidth + 'px' }, [el('img', { src: c.image, alt: '' })]) : null
    ]);
  };

  /* Result logic: first result that lists this Lash look + Eye shape pair, else the fallback result. */
  Quiz.prototype.pickResult = function () {
    var key = this.answers[this.cfg.logic.lookQuestion] + '|' + this.answers[this.cfg.logic.eyeQuestion];
    var results = Array.prototype.slice.call(this.resultsWrap.querySelectorAll('[data-alq-result]'));
    var match = results.filter(function (r) { return (r.dataset.match || '').split(';').indexOf(key) !== -1; })[0];
    this.result = match || results.filter(function (r) { return r.hasAttribute('data-fallback'); })[0] || results[0];
  };

  /* Theme editor: selecting a Result block previews it. */
  Quiz.prototype.preview = function (resultEl) {
    this.result = resultEl;
    var all = this.resultsWrap.querySelectorAll('[data-alq-result]');
    Array.prototype.forEach.call(all, function (r) { r.hidden = r !== resultEl; });
    this.stage.hidden = true;
    this.resultsWrap.hidden = false;
  };

  /* restored = true when re-opening saved results: no Klaviyo event, no new save. */
  Quiz.prototype.showResult = function (restored) {
    var self = this;
    var all = this.resultsWrap.querySelectorAll('[data-alq-result]');
    Array.prototype.forEach.call(all, function (r) { r.hidden = r !== self.result; });
    this.stage.hidden = true;
    this.stage.innerHTML = '';
    this.resultsWrap.hidden = false;
    this.fillPressOnTip();
    this.scrollTop();
    this.updateOffer();
    if (restored) return;
    var name = this.result ? this.result.dataset.resultName : '';
    this.trackKlaviyo('Completed Lash Quiz', this.profileProps(name));
    document.dispatchEvent(new CustomEvent('lashquiz:result', { detail: { result: name, answers: this.answers, emailGiven: this.emailGiven } }));
  };

  /* Used by al-lash-quiz-memory.js ("Go back to my results" / "Take another quiz"). */
  Quiz.prototype.showSaved = function (answers, emailGiven) {
    this.answers = Object.assign({}, answers);
    this.emailGiven = this.emailGiven || Boolean(emailGiven);
    this.email = '';
    this.pickResult();
    this.showResult(true);
  };

  Quiz.prototype.restart = function () {
    this.answers = {};
    this.email = '';
    this.result = null;
    this.go(0);
  };

  /* First-order code. No background request here (a background discount request can create a
   * second cart and drop an item added at the same moment). Instead:
   * - product photo/name links go through Shopify's discount link (a normal page visit);
   * - add to cart puts the code on that same cart right after the item (see addToCart). */
  Quiz.prototype.discountUnlocked = function () {
    return Boolean(this.cfg.discountCode) && (!this.cfg.discountRequiresEmail || this.emailGiven);
  };

  /* Shows the "20% off applied" bar to visitors who left their email, the unlock box to the others. */
  Quiz.prototype.updateOffer = function () {
    if (!this.result) return;
    var unlocked = this.discountUnlocked();
    var bar = this.result.querySelector('[data-alq-offer-unlocked]');
    var form = this.result.querySelector('[data-alq-unlock]');
    if (bar) bar.hidden = !unlocked;
    if (form) form.hidden = unlocked;
    if (unlocked) this.applyDiscount();
  };

  /* Email given on the results page: subscribe, unlock the code, and put it on an existing cart. */
  Quiz.prototype.unlock = function (form) {
    var self = this;
    var input = form.querySelector('input[type="email"]');
    var error = form.querySelector('[data-alq-unlock-error]');
    var value = input.value.trim();
    if (!EMAIL_RE.test(value)) {
      error.textContent = this.cfg.email.invalidText;
      input.focus();
      return;
    }
    error.textContent = '';
    this.email = value;
    this.emailGiven = true;
    this.captureEmail(value);
    var name = this.result ? this.result.dataset.resultName : '';
    this.trackKlaviyo('Completed Lash Quiz', this.profileProps(name));
    this.updateOffer();
    document.dispatchEvent(new CustomEvent('lashquiz:unlocked', { detail: { result: name } }));
    // Items already in the cart get the code too. Only touch an existing cart, never create one.
    if (/(?:^|; )cart=/.test(document.cookie)) {
      fetch(this.cfg.routes.cart + '.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (!cart.item_count || self.hasOtherCode(cart)) return;
          return fetch(self.cfg.routes.cartUpdate, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: self.cfg.discountCode })
          }).then(function () { self.refreshCart(); });
        })
        .catch(function () {});
    }
  };

  Quiz.prototype.applyDiscount = function () {
    var code = this.cfg.discountCode;
    if (!code || !this.result || !this.discountUnlocked()) return;
    var cookie = (document.cookie.match(/(?:^|; )discount_code=([^;]*)/) || [])[1];
    if (cookie && decodeURIComponent(cookie).toUpperCase() !== code.toUpperCase()) return; // keep a code they already have
    Array.prototype.forEach.call(this.result.querySelectorAll('a[data-alq-product-link]'), function (link) {
      if (link.dataset.alqDiscounted) return;
      link.dataset.alqDiscounted = '1';
      link.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(link.getAttribute('href'));
    });
  };

  /* True when the cart already carries a different discount code (e.g. from an email). */
  Quiz.prototype.hasOtherCode = function (cart) {
    var code = (this.cfg.discountCode || '').toUpperCase();
    return (cart.discount_codes || []).some(function (d) { return d.applicable && d.code.toUpperCase() !== code; });
  };

  /* Press-on placement map follows the eye shape answer. */
  Quiz.prototype.fillPressOnTip = function () {
    if (!this.result) return;
    var tips = (this.cfg.pressOn && this.cfg.pressOn.tips) || {};
    var tip = tips[this.answers[this.cfg.logic.eyeQuestion]];
    var wrap = this.result.querySelector('[data-alq-presson-tip]');
    if (!wrap) return;
    wrap.hidden = !tip;
    if (tip) wrap.querySelector('[data-alq-presson-tip-text]').textContent = tip;
  };

  /* ---------- Klaviyo ---------- */

  Quiz.prototype.profileProps = function (resultName) {
    var props = {};
    var self = this;
    this.cfg.questions.forEach(function (q) {
      if (self.answers[q.id]) props['Lash Quiz - ' + q.klaviyoLabel] = self.answers[q.id];
    });
    if (resultName) props['Lash Quiz - Result'] = resultName;
    if (resultName && this.result && this.result.dataset.pressonName) props['Lash Quiz - Press-on match'] = this.result.dataset.pressonName;
    return props;
  };

  Quiz.prototype.captureEmail = function (email) {
    var props = this.profileProps();
    props.email = email;
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify(props);
      } else {
        var legacy = { $email: email };
        Object.keys(props).forEach(function (k) { if (k !== 'email') legacy[k] = props[k]; });
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', legacy]);
      }
    } catch (e) { /* never block the quiz on tracking */ }

    var k = this.cfg.klaviyo;
    if (!k.publicKey || !k.listId) return;
    // List ID setting may hold several lists, comma separated (e.g. a quiz list + the main newsletter list).
    k.listId.split(',').map(function (id) { return id.trim(); }).filter(Boolean).forEach(function (listId) {
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(k.publicKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: k.source,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      })
        .then(function (res) {
          if (!res.ok) res.text().then(function (t) { console.warn('[Lash quiz] Klaviyo subscription failed', res.status, t); });
        })
        .catch(function (err) { console.warn('[Lash quiz] Klaviyo subscription error', err); });
    });
  };

  Quiz.prototype.trackKlaviyo = function (event, props) {
    if (!this.email) return;
    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.identify({ email: this.email });
        window.klaviyo.track(event, props);
        window.klaviyo.identify(props);
      } else {
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', Object.assign({ $email: this.email }, props)]);
        window._learnq.push(['track', event, props]);
      }
    } catch (e) { /* ignore */ }
  };

  /* ---------- Results: purchase options + add to cart ---------- */

  Quiz.prototype.bindResults = function () {
    var self = this;
    this.resultsWrap.addEventListener('change', function (e) {
      var card = e.target.closest('[data-alq-card]');
      if (!card) return;
      if (e.target.matches('[data-alq-purchase]') || e.target.matches('[data-alq-plan-select]') || e.target.matches('[data-alq-variant]')) {
        self.syncCard(card);
      }
    });
    this.resultsWrap.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-alq-unlock]');
      if (!form) return;
      e.preventDefault();
      self.unlock(form);
    });
    this.resultsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-alq-atc]');
      if (!btn) return;
      e.preventDefault();
      if (btn.dataset.added === '1') { window.location.href = self.cfg.routes.cart; return; }
      self.addToCart(btn.closest('[data-alq-card]'), btn);
    });
    Array.prototype.forEach.call(this.resultsWrap.querySelectorAll('[data-alq-card]'), function (card) { self.syncCard(card); });
  };

  Quiz.prototype.cardVariant = function (card) {
    var variants = JSON.parse(card.querySelector('script[data-alq-variants]').textContent);
    var picker = card.querySelector('[data-alq-variant]');
    var id = picker ? Number(picker.value) : variants[0].id;
    return variants.filter(function (v) { return v.id === id; })[0] || variants[0];
  };

  Quiz.prototype.syncCard = function (card) {
    var variant = this.cardVariant(card);
    var btn = card.querySelector('[data-alq-atc]');
    var subscribe = card.querySelector('[data-alq-purchase][value="subscribe"]');
    var select = card.querySelector('[data-alq-plan-select]');
    var isSub = subscribe && subscribe.checked;
    if (select) select.hidden = !isSub;
    var planId = isSub && select ? select.value : '';

    var priceEl = card.querySelector('[data-alq-price]');
    var compareEl = card.querySelector('[data-alq-compare]');
    if (priceEl) priceEl.textContent = planId && variant.plans[planId] ? variant.plans[planId] : variant.price_f;
    if (compareEl) {
      compareEl.hidden = !(variant.compare > variant.price);
      compareEl.textContent = variant.compare_f;
    }
    var oneTimeLabel = card.querySelector('[data-alq-onetime-price]');
    if (oneTimeLabel) oneTimeLabel.textContent = '(' + variant.price_f + ')';

    if (btn.dataset.added === '1') return;
    if (!variant.available) {
      btn.disabled = true;
      btn.textContent = this.cfg.text.soldOut;
    } else {
      btn.disabled = Boolean(isSub && !planId);
      btn.textContent = this.cfg.text.addToCart;
    }
  };

  Quiz.prototype.addToCart = function (card, btn) {
    var self = this;
    var variant = this.cardVariant(card);
    var qtyInput = card.querySelector('[data-alq-qty]');
    var qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
    var subscribe = card.querySelector('[data-alq-purchase][value="subscribe"]');
    var select = card.querySelector('[data-alq-plan-select]');
    var item = { id: variant.id, quantity: qty };
    if (subscribe && subscribe.checked && select && select.value) item.selling_plan = Number(select.value);

    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = self.cfg.text.adding;

    var job = function () {
      return fetch(self.cfg.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
          return data;
        });
      })
      .then(function () {
        var resultName = self.result ? self.result.dataset.resultName : '';
        // Quiz attribution on the order (hidden from the customer, visible on the order in admin),
        // plus the first-order code on the cart unless it already carries another code.
        return fetch(self.cfg.routes.cart + '.js', { credentials: 'same-origin' })
          .then(function (res) { return res.json(); })
          .catch(function () { return {}; })
          .then(function (cart) {
            var body = { attributes: { _lash_quiz_result: resultName } };
            if (self.discountUnlocked() && !self.hasOtherCode(cart)) body.discount = self.cfg.discountCode;
            return fetch(self.cfg.routes.cartUpdate, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body)
            });
          })
          .catch(function () {});
      })
      .then(function () {
        btn.dataset.added = '1';
        btn.disabled = false;
        btn.textContent = self.cfg.text.viewCart;
        self.openCart();
        document.dispatchEvent(new CustomEvent('lashquiz:addtocart', { detail: { item: item } }));
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = original;
        window.alert(err.message);
      });
    };
    // One add at a time: two adds racing on a brand-new visitor would each create their own cart.
    this.cartQueue = (this.cartQueue || Promise.resolve()).then(job);
  };

  Quiz.prototype.refreshCart = function () {
    try {
      if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') window.Rebuy.Cart.fetchCart();
    } catch (e) { /* ignore */ }
  };

  Quiz.prototype.openCart = function () {
    // Rebuy Smart Cart refreshes and opens itself on /cart/add.js; this is a safety net.
    try {
      var r = window.Rebuy;
      if (r && r.Cart && typeof r.Cart.fetchCart === 'function') r.Cart.fetchCart();
      if (r && r.SmartCart && typeof r.SmartCart.show === 'function') {
        setTimeout(function () { if (!document.body.classList.contains('rebuy-cart-visible')) r.SmartCart.show(); }, 600);
        return;
      }
    } catch (e) { /* ignore */ }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  };

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-alq]'), function (root) {
      if (root.alqQuiz) return;
      root.alqQuiz = new Quiz(root);
      document.dispatchEvent(new CustomEvent('lashquiz:ready', { detail: { quiz: root.alqQuiz } }));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', function (e) {
    var resultEl = e.target.closest && e.target.closest('[data-alq-result]');
    var root = resultEl && resultEl.closest('[data-alq]');
    if (root && root.alqQuiz) root.alqQuiz.preview(resultEl);
  });
})();
